module.exports = __webpack_public_path__ + "img/17.e21e95c2.png";